import hoistNonReactStatic from 'hoist-non-react-statics';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Breakpoints, getWindowWidth } from '@zocdoc/components/src/grid';
import getDisplayName from '../../utils/displayName';
import { DEVICE_TYPES, VIEWPORT_KEY } from './constants';
import { setDeviceType } from './actions';

const instances = new Map();

export function widthToDeviceType(width) {
    // Currently deviceType and window size are linked together
    // However if this ever neeeds to be separated, this can be refactored
    let newDeviceType = DEVICE_TYPES.Desktop;
    const isMobile = width < Breakpoints.medium;
    if (isMobile) {
        const isTablet = width >= Breakpoints.small;
        newDeviceType = isTablet ? DEVICE_TYPES.Tablet : DEVICE_TYPES.Mobile;
    }
    return newDeviceType;
}

export default WrappedComponent => {
    const wrappedDisplayName = `ViewportWrapper(${getDisplayName(WrappedComponent)})`;

    const getStateFromProps = props => {
        const {
            __forceDesktopViewport,
            deviceType,
            isDesktop,
            isMobile,
            isTablet,
        } = props;

        // __forceDesktopViewport overrides given device props
        // Should not be used for anything but testing
        // Otherwise, just pass props to state
        if (__forceDesktopViewport) {
            return {
                deviceType: DEVICE_TYPES.Desktop,
                isDesktop: true,
                isMobile: false,
                isTablet: false,
            };
        } else {
            return {
                deviceType,
                isDesktop,
                isMobile,
                isTablet,
            };
        }
    };

    class ViewportWrapper extends React.Component {
        static propTypes = {
            isDesktop: PropTypes.bool,
            isMobile: PropTypes.bool,
            isTablet: PropTypes.bool,
            deviceType: PropTypes.string,
            // Used for screenshot tests
            __forceDesktopViewport: PropTypes.bool,
        };

        static displayName = wrappedDisplayName;

        constructor(props) {
            super(props);
            this.state = getStateFromProps(props);
        }

        static getDerivedStateFromProps(props) {
            return getStateFromProps(props);
        }

        componentDidMount() {
            if (instances.size === 0) {
                window.addEventListener('resize', this.handleResizeForAll, true);
                this.handleResizeForAll();
            }

            instances.set(this, true);
        }

        componentWillUnmount() {
            instances.delete(this);

            if (instances.size === 0) {
                window.removeEventListener('resize', this.handleResizeForAll, true);
            }
        }

        handleResizeForAll = () => {
            // This should only fire once per resize
            this.props.setDeviceType(widthToDeviceType(getWindowWidth()));
        };


        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    {...this.state}
                />
            );
        }
    }

    hoistNonReactStatic(ViewportWrapper, WrappedComponent);

    const mapDispatchToProps = {
        setDeviceType,
    };

    return connect(state => state[VIEWPORT_KEY], mapDispatchToProps)(ViewportWrapper);
};
